/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Portal Users module

define('modules/PortalUser/PortalUsers.Forms',[], function () {
	'use strict';

	// Forms definitions
	var forms = {	
		'PortalLogin': {
			Fields: [
                { 'Name': 'Email', 'Field': '#portalLoginEmail', 'Param': 'username', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Password', 'Field': '#portalLoginPassword', 'Param': 'password', 'Type': 'Text' },
                { 'Name': 'KeepLoggednIn', 'Field': '#protalLoginKeep', 'Param': 'keepLoggedIn', 'Type': 'Checkbox', 'Optional': true }
			],
			Validate: true
		},
		'PortalRegistration': {
			Fields: [                
                {
                	'Name': 'First Name',
                	'Field': '#portalRegisterFirstName',
                	'Param': 'firstName',
                	'Type': 'Text',
                	'Validators': [{
                	    'Type': 'TextOnly'
                	}]
                },
                {
                	'Name': 'Last Name',
                	'Field': '#portalRegisterLastName',
                	'Param': 'lastName',
                	'Type': 'Text',
                	'Validators': [{
                	    'Type': 'TextNumbersHyphen'
                	}]
                },
                {
                	'Name': 'Email',
                	'Field': '#portalRegisterEmail',
                	'Param': 'email',
                	'Type': 'Text',
                	'Validators': [{
                		'Type': 'Email'
                	}]
                },
                {
                	'Name': 'Confirm Email',
                	'Field': '#portalRegisterEmail2',
                	'Param': 'emailConfirm',
                	'Type': 'Text',
                	'Validators':
                        [
                            { 'Type': 'Email' },
                            {
                            	'Type': 'ConfirmField',
                            	'OriginField': '#portalRegisterEmail',
                            	'ErrorMsg': 'Email does not match the confirm email.'
                            }]
                },
                {
                	'Name': 'Password',
                	'Field': '#portalRegisterPassword',
                	'Param': 'password',
                	'Type': 'Text'
                },
                {
                	'Name': 'Confirm Password',
                	'Field': '#portalRegisterPassword2',
                	'Param': 'passwordConfirm',
                	'Type': 'Text',
                	'Validators':
                        [
                            {
                            	'Type': 'ConfirmField',
                            	'OriginField': '#portalRegisterPassword',
                            	'ErrorMsg': 'Password does not match the confirm password.'
                            }]
                },
                {
                    'Name': 'JobTitle',
                    'Field': '#portalRegisterJobTitle',
                    'Param': 'jobTitle',
                    'Type': 'Text'
                },
                {
                    'Name': 'BillingStreetAddress',
                    'Field': '#portalRegisterBillingStreetAddress',
                    'Param': 'billingStreetAddress',
                    'Type': 'Text'
                },
                {
                    'Name': 'City',
                    'Field': '#portalRegisterCity',
                    'Param': 'city',
                    'Type': 'Text'
                },
                {
                    'Name': 'Country',
                    'Field': '#portalRegisterCountry',
                    'Param': 'country',
                    'Type': 'Select'
                },
                {
                    'Name': 'State',
                    'Field': '#portalRegisterState',
                    'Param': 'state',
                    'Type': 'Select'
                },
                {
                    'Name': 'Zip',
                    'Field': '#portalRegisterZip',
                    'Param': 'zip',
                    'Type': 'Text'
                },
                {
                	'Name': 'Organization',
                	'Field': '#portalRegisterOrganization',
                	'Param': 'organizationName',
                	'Type': 'Text'
                },
                {
                	'Name': 'Phone Number',
                	'Field': '#portalRegisterPhone',
                	'Param': 'phoneNumber',
                	'Optional': true,
                	'Type': 'Text',
                	"Validators": [
                                              {
                                              	"Type": 'Phone'
                                              }
                	]
                },
                {
                	'Name': 'Account Number',
                	'Field': '#portalRegisterAccountNumber',
                	'Optional': true,
                	'Param': 'accountNumber',
                	'Type': 'Text'
                }              
			],
			Validate: true
		},
		'ForgotPassword': {
			Fields: [
                { 'Name': 'Email', 'Field': '#forgot_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] }
			],
			Validate: true
		},
		'ChangePassword': {
			Fields: [
                { 'Name': 'User id', 'Field': '#forgot_user_id', 'Param': 'userId', 'Type': 'Hidden' },
                { 'Name': 'Password', 'Field': '#forgot_password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Confirm Password', 'Field': '#forgot_password2', 'Type': 'Text' }
			],
			Validate: true
		},
		'EditAccount': {
			Fields: [
                { 'Name': 'Password', 'Field': '#current-password', 'Param': 'currentPassword', 'Type': 'Text' },
                { 'Name': 'New Password', 'Field': '#new-password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Retype New Password', 'Field': '#new-password-confirm', 'Type': 'Text' }
			],
			Validate: true
		},
		'EditProfile': {
			Fields: [
                { 'Name': 'First Name', 'Field': '#first-name', 'Param': 'firstName', 'Type': 'Text' },
                { 'Name': 'Last Name', 'Field': '#last-name', 'Param': 'lastName', 'Type': 'Text' },
                { 'Name': 'LinkedIn Profile', 'Field': '#linkedin-profile', 'Param': 'linkedInProfile', 'Type': 'Text', 'Optional': true }
			],
			Validate: true
		},
	};

	return forms;
});
